import { jsx as _jsx } from "react/jsx-runtime";
export function LoadingBar({ active }) {
    if (!active) {
        // Reserve 2px of height to prevent layout shift
        return _jsx("div", { style: { height: 2 } });
    }
    return (_jsx("div", { className: "ac-loading-bar", children: _jsx("div", { className: "ac-loading-bar-fill" }) }));
}
//# sourceMappingURL=LoadingBar.js.map